import { useNavigate } from 'react-router-dom'

export default function NotFound() {
  const navigate = useNavigate()
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#F8FAFC', padding: 24, textAlign: 'center' }}>
      <div style={{ fontSize: 64, marginBottom: 16 }}>🌊</div>
      <h1 style={{ fontSize: 24, fontWeight: 800, color: '#1A1F2E', margin: '0 0 8px' }}>Page introuvable</h1>
      <p style={{ fontSize: 14, color: '#64748B', margin: '0 0 24px' }}>Ce lien n'existe pas ou a expiré.</p>
      <button onClick={() => navigate('/')}
        style={{ padding: '12px 24px', borderRadius: 10, background: '#0E4D6B', color: '#fff', border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
        Retour à l'accueil
      </button>
    </div>
  )
}
